import Contract from "entities/Contract";
import ContractTypePageSetup from "entities/ContractTypePageSetup";

export const pageAllowed = (
  itemCode: string,
  contract: Contract | null,
  contractTypePageSetup: ContractTypePageSetup[],
  itemIds: string[]
) => {

    if (itemCode === "0") return true;

  if (!contract || !itemIds || !contractTypePageSetup || !itemCode) {
    return false;
  }

  const currentItemIsIncluded = itemIds.includes(itemCode);
  return (
    !!contractTypePageSetup.find(
      c =>
        c.SystemContractType === contract.SystemType &&
        c.SelfServicePageCode === itemCode &&
        c.Enabled
    ) && currentItemIsIncluded
  );
};
